import React from "react"
import { NavLink as Link } from "react-router-dom"
import { formatNumber, Avatar, withContainers } from "../../../normalizer"
import { CampaignUserContainer } from "../../../../containers/gamification2026"

const UserBadge = ({ user, campaignUser }) => {
  const { first_name: firstName, last_name: lastName } = user
  const { availablePoints, avatar: campaignAvatar = {} } = campaignUser

  let avatar = undefined
  if (campaignAvatar && campaignAvatar.url) {
    avatar = campaignAvatar.url
  }

  // Get shortened name: "António M." format
  const normalizedFirstName = firstName !== null ? firstName : ''
  const normalizedLastName = lastName !== null ? lastName : ''
  const splitFirstName = normalizedFirstName.split(' ')
  const splitLastName = normalizedLastName.split(' ')
  const shortFirstName = splitFirstName[0]
  const lastInitial = splitLastName[0] ? splitLastName[0].charAt(0) + '.' : ''
  const shortName = shortFirstName + (lastInitial ? ' ' + lastInitial : '')

  return (
    <Link to="/profile" className="gl-user-badge">
      <div className="gl-user-badge__avatar-wrapper">
        <img
          src={avatar || Avatar}
          alt="user"
          className="gl-user-badge__avatar"
        />
      </div>
      <span className="gl-user-badge__name">{shortName}</span>
      <span className="gl-user-badge__points">
        {formatNumber(availablePoints)}
      </span>
    </Link>
  )
}

export default withContainers(UserBadge, [CampaignUserContainer])

